var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:{
    'tw-space-y-2 tw-mb-2': _vm.isPluginFree(_vm.plugin),
    'tw-space-y-4 tw-mb-4': !_vm.isPluginFree(_vm.plugin),
  }},[_vm._l((_vm.plugin.editions),function(edition,key){return [_c('div',{key:key},[_c('plugin-edition',{attrs:{"plugin":_vm.plugin,"edition":edition,"context":"meta"}})],1)]})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }